import CircularProgress from "@material-ui/core/CircularProgress";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Component } from "react";
import locales from "../../../_constants/locales";
import StatusProgressBar from "../../../components/StatusProgressBar.jsx";
import StyledButton from "../../../components/StyledButton.jsx";
import RequestDetails from "./RequestDetails.jsx";

class RequestSection extends Component {
    renderActionLabel(action) {
        if (!action || !action.label) {
            return null;
        }

        if (!action.icon || action.icon !== "download") {
            return action.label;
        }

        return (
            <span className="tracking-button-content">
                <span>{action.label}</span>
                <GetAppIcon className="tracking-button-icon" aria-hidden="true" />
            </span>
        );
    }

    render() {
        var requestIsCancelled =
            this.props.request && this.props.request.requestLogs && this.props.request.requestLogs.some(rl => rl.status.code === "CANCELLED");

        return (
            <div className="section request-section">
                <div className="section-header">
                    <div className="layout horizontal center title-row">
                        <h2 className="title flex">
                            {locales[this.props.language.code].REQUEST_TYPE[this.props.request.requestType.code]}{" "}
                            {locales[this.props.language.code].TICKET_CONFIRMATION.REQUEST_DETAILS.TITLE}
                            {requestIsCancelled && ` - ${locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS["CANCELLED"].TITLE}`}
                        </h2>
                        {!this.props.requestIsCancelled && this.props.view === "TICKET_PAGE" && this.props.actions && (
                            <div className="actions layout horizontal end">
                                {this.props.actions.map((action, i) => (
                                    <StyledButton key={i} disabled={action.disabled} onClick={action.onClick} variant="contained" className="styled-button">
                                        {this.renderActionLabel(action)}
                                    </StyledButton>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div className="section-body">
                    <div className="flex layout vertical">
                        <div className="flex">
                            {this.props.view === "TICKET_PAGE" && this.props.isStatusProgressBarVisible && !requestIsCancelled && (
                                <StatusProgressBar request={this.props.request} language={this.props.language} />
                            )}
                            {this.props.view === "TICKET_PAGE" && this.props.isStatusProgressBarVisible && requestIsCancelled && (
                                <div className="flex layout horizontal current-status-description">
                                    <p>{locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS["CANCELLED"].DESCRIPTION}</p>
                                </div>
                            )}
                            <RequestDetails
                                request={this.props.request}
                                handleChange={this.props.handleChange ? this.props.handleChange.bind(this) : null}
                                view={this.props.view}
                                language={this.props.language}
                                requestIsCancelled={requestIsCancelled}
                            />
                        </div>
                    </div>
                </div>
                {!requestIsCancelled && this.props.actions && this.props.actions.length > 0 && <div className="horizontal-separator-inner dynamic" />}
                {!requestIsCancelled && this.props.actions && this.props.actions.length > 0 && (
                    <div className="section-footer">
                        <div className="mobile-actions">
                            {this.props.actions &&
                                this.props.actions.map((action, i) => (
                                    <StyledButton key={i} variant="contained" onClick={action.onClick} label={action.label} disabled={action.disabled}>
                                        {this.renderActionLabel(action)}
                                        {action.loading && <CircularProgress className="button-progress" size={16} thickness={4} />}
                                    </StyledButton>
                                ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default RequestSection;
